import { showPivotEnableDisableDialog } from '../actions/publicActions';
import { mutator } from 'satcheljs';
import store from '../store/Store';
import InboxPlusPivotViewState from 'owa-mail-inbox-plus-store/lib/store/schema/InboxPlusPivotViewState';
import inboxPlusStore from 'owa-mail-inbox-plus-store/lib/store/Store';

mutator(showPivotEnableDisableDialog, actionMessage => {
    // deep copy current pivots from user configuration
    store.enabledDisabledPivots = inboxPlusStore.inboxPlusPivots.map(
        (pivot: InboxPlusPivotViewState) => ({
            ...pivot,
        })
    );
});
